import React, { useEffect, useState } from 'react'
import Sidebaar from '../Component/Sidebar'
import { Form, ToastContainer } from 'react-bootstrap'
import TitleComp from '../Component/TitleComp'
import axios from 'axios'
import { Base_Url } from '../BaseUrl'
import { Bars } from 'react-loader-spinner'
import { toast } from 'react-toastify'

function ContactUs() {
    const [mobile, setmobile] = useState("")
    const [email, setemail] = useState("")
    const [whatsapp, setwhatsapp] = useState("")
    const [description, setdescription] = useState("")
    const [loading, setloading] = useState(false)
    const [edit, setedit] = useState("")

    let token = localStorage.getItem("token")

    const headers = {
        Authorization: `Bearer ${token}`
    }


    const handleget = () => {
        axios.get(`${Base_Url}/complain?contact=1`, { headers }).then((res) => {
            setedit(res.data.data?.[0]._id)
            setemail(res.data.data?.[0].email)
            setmobile(res.data.data?.[0].phone)
            setwhatsapp(res.data.data?.[0].whatsapp_phone)
            setdescription(res.data.data?.[0].message)
        })
    }

    useEffect(() => {
        handleget()
    }, [])
    const handleSubmit = (e) => {
        e.preventDefault()
        setloading(true)
        let requestdata = {
            _id: edit,
            message: description,
            email: email,
            subject: "forContact",
            phone: mobile,
            type: "Contact",
            whatsapp_phone: whatsapp
        }
        axios.put(`${Base_Url}/complain`, requestdata, { headers }).then((res) => {

            if (res.data.error == "0") {
                toast.success("Data Submitted Successfully")
            }
        }).finally(() => {
            setloading(false)
        })
    }
    return (
        <>
            <ToastContainer />
            {loading && (
                <div className="overlay">
                    <Bars
                        height="80"
                        width="80"
                        color="#051322"
                        ariaLabel="bars-loading"
                        visible={true}
                    />
                </div>
            )}
            <Sidebaar content={
                <>
                    <Form onSubmit={(e) => handleSubmit(e)}>
                        <div className="row gy-3">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <TitleComp title="Contact Us" />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="">Mobile</label>
                                <input type="text" minLength={10} maxLength={10} value={mobile} onChange={(e) => setmobile(e.target.value)} className='form-control' />

                            </div>
                            <div className="col-md-4">
                                <label htmlFor="">Email</label>
                                <input type="email" value={email} onChange={(e) => setemail(e.target.value)} className='form-control' />

                            </div>
                            <div className="col-md-4">
                                <label htmlFor="">WhatsApp Number</label>
                                <input type="text" minLength={10} maxLength={10} value={whatsapp} onChange={(e) => setwhatsapp(e.target.value)} className='form-control' />

                            </div>
                            <div className="col-md-12">
                                <label htmlFor="">Description</label>
                                <textarea name="" value={description} onChange={(e) => setdescription(e.target.value)} className='form-control' id=""></textarea>

                            </div>
                            <div className="col-md-12">
                                <button className='btn bg-dark text-white'>Submit</button>
                            </div>
                        </div>
                    </Form>
                </>
            } />


        </>
    )
}

export default ContactUs





